<style
  lang="less"
  scoped="">
  .review_tag {
    padding: 20px 20px 10px 20px;
    border-bottom: 1px solid #eee;
  }

  .tagefer {
    margin-right: 35px;
    width: 120px;
    height: 26px !important;
    font-size: 16px !important;
    color: #0077db !important;
    text-align: center;
    cursor: pointer;
  }

  .pinglun_row {
    border-bottom: 1px solid #eee;
    padding: 0 12px 10px 12px;
  }

</style>

<template>
  <div>
    <div class="review_tag">
      <el-tag
        v-for="(item, index) in reviewTags"
        class="tagefer"
        type="primary"
        color="white"
      >
        {{ item.tag.value }}({{ item.count }})
      </el-tag>
    </div>

    <div v-for="item in reviews" style="margin-top: 10px;">
      <el-row class="pinglun_row">
        <el-col :span="12">
          <p style="font-size: 12px; color: #686868; white-space: normal; margin-bottom: 10px;">
            {{ item.content }}
          </p>
          <span v-for="tag in item.tags">{{tag.tag.value}}</span>
          <p style="font-size: 12px; color: #9a9a9a;">
            {{ getLocalTime(item.createAt) }}
          </p>
        </el-col>
        <el-col :span="12"
                style="text-align: center;">
          <div style="margin-top: 15px"></div>
          <p style="font-size: 12px;color: #333;">
            用户：{{ item.user.phone }}
          </p>
        </el-col>
      </el-row>
    </div>

  </div>

</template>

<script>
  import productApi from '../../api/product'

  export default {
    data() {
      return {
        currentReviews: [],
        reviewTags: []
      }
    },
    props: {
      reviews: Array,
      pureSerialId: String,
    },
    methods: {
      getLocalTime(nS) {
        return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/, ' ')
      },
      showReviewsByRate(rate) {
        let vm = this
        vm.currentReviews = _.filter(vm.reviews, {'star': rate})
      },
      async fetchData(pureSerialId) {
        let reviewTags = await productApi.getReviewTags(pureSerialId)
        this.reviewTags = reviewTags
      }
    },
    mounted() {
      this.fetchData(this.pureSerialId)
    }
  }
</script>



// WEBPACK FOOTER //
// ReviewList.vue?2c6412a6